import { render } from "./TabChild.vue?vue&type=template&id=6d33b5c5&scoped=true"
import script from "./TabChild.vue?vue&type=script&lang=js"
export * from "./TabChild.vue?vue&type=script&lang=js"

import "./TabChild.vue?vue&type=style&index=0&id=6d33b5c5&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d33b5c5"]])

export default __exports__